import { r2 } from "./shapes";

/*
 * Wedding music and ornaments: the shehnai (the wedding oboe with its brass bell) and
 * the latkan (a hanging tassel ornament). The dholak the guest can play is a painting
 * (../Dholak.js).
 */

/**
 * Shehnai, bell down: reed, wooden body with finger holes and gold rings, flared
 * brass bell, and a ribbon tied below the reed. viewBox 0 0 60 260.
 */
export const Shehnai = ({ className = "", ribbon = "#d81b60" }) => (
  <svg className={`ut-shehnai ${className}`} viewBox="0 0 60 260" aria-hidden="true">
    {/* Reed and its gold disc */}
    <path d="M28.6,4 L31.4,4 L31,22 L29,22 Z" fill="#e8d6a8" />
    <ellipse cx="30" cy="24" rx="9" ry="2.6" fill="url(#ut-gold-h)" />
    {/* Body: a slow cone */}
    <path d="M26,26 L34,26 L38,184 L22,184 Z" fill="url(#ut-wood)" />
    {[40, 92, 150, 178].map((y) => (
      <rect key={y} x={r2(25 - (y - 26) * 0.025)} y={y} width={r2(10 + (y - 26) * 0.05)} height="4" rx="1" fill="url(#ut-gold-h)" />
    ))}
    {[58, 70, 82, 104, 116, 128, 140].map((y) => (
      <ellipse key={y} cx="30" cy={y} rx="1.8" ry="1.3" fill="#2b170b" />
    ))}
    {/* Bell */}
    <path d="M22,184 L38,184 C40,214 50,236 58,250 C44,258 16,258 2,250 C10,236 20,214 22,184 Z" fill="url(#ut-gold-h)" />
    <ellipse cx="30" cy="250" rx="28" ry="6" fill="#b5841f" />
    <ellipse cx="30" cy="249" rx="23" ry="3.6" fill="#7c5410" />
    <path d="M26,196 C24,218 16,236 10,246" fill="none" stroke="#fff6d8" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round" />
    {/* Ribbon */}
    <path d="M24,34 C10,44 6,62 12,80 M36,34 C46,48 46,66 40,84" fill="none" stroke={ribbon} strokeWidth="3" strokeLinecap="round" />
    <circle cx="30" cy="34" r="4" fill={ribbon} />
    <path d="M12,80 l-3,8 l7,-2 Z M40,84 l-1,8 l6,-4 Z" fill="#f6b21b" />
  </svg>
);

/**
 * Latkan: a gold cord, beads, a domed cap and a fringe of silk threads.
 * viewBox 0 0 40 170 (hangs from the top centre).
 */
export const Latkan = ({ className = "", color = "#d81b60", bead = "#f6b21b" }) => {
  const threads = Array.from({ length: 13 }, (_, i) => {
    const x = 12 + i * (16 / 12);
    const spread = (x - 20) * 0.45;
    return `M${r2(x)},118 Q${r2(x + spread * 0.4)},140 ${r2(x + spread)},162`;
  });
  return (
    <svg className={`ut-latkan ${className}`} viewBox="0 0 40 170" aria-hidden="true">
      <line x1="20" y1="0" x2="20" y2="70" stroke="#c9962b" strokeWidth="1.4" />
      <circle cx="20" cy="30" r="4.2" fill={bead} />
      <circle cx="20" cy="44" r="3.2" fill="#1b8a5a" />
      <circle cx="20" cy="56" r="4.2" fill={color} />
      <ellipse cx="20" cy="70" rx="3" ry="4.6" fill="url(#ut-gold)" />
      {/* Dome cap with mirror dots */}
      <path d="M8,104 C8,84 14,76 20,76 C26,76 32,84 32,104 Z" fill={color} />
      <path d="M8,104 C8,84 14,76 20,76 C26,76 32,84 32,104 Z" fill="url(#ut-sheen)" />
      <rect x="6" y="102" width="28" height="6" rx="2" fill="url(#ut-gold-h)" />
      <use href="#ut-mirror" x="17" y="86" width="6" height="6" />
      {/* Fringe */}
      <g fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round">
        {threads.map((d) => (
          <path key={d} d={d} />
        ))}
      </g>
      <rect x="9" y="110" width="22" height="8" rx="3" fill={bead} />
      <path d="M9,114 L31,114" stroke="#fff" strokeOpacity="0.5" strokeWidth="1" strokeDasharray="2 2" />
    </svg>
  );
};

/** Small brass temple bell, for torans. viewBox 0 0 24 40. */
export const Bell = ({ className = "" }) => (
  <svg className={`ut-bell ${className}`} viewBox="0 0 24 40" aria-hidden="true">
    <line x1="12" y1="0" x2="12" y2="12" stroke="#c9962b" strokeWidth="1.2" />
    <circle cx="12" cy="13" r="2.4" fill="url(#ut-gold)" />
    <path d="M12,14 C5,14 4,24 3,32 L21,32 C20,24 19,14 12,14 Z" fill="url(#ut-gold)" />
    <rect x="1.5" y="31" width="21" height="3" rx="1.5" fill="#b5841f" />
    <circle cx="12" cy="37" r="2.4" fill="#a8761c" />
  </svg>
);
